import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../helpers';
import { AppContextProvider } from '../../Services/AppContext';
import TimelineGrid from '../TimelineGrid/TimelineGrid';
import Collapse from '../HealthPlan/Collapse/Collapse';
import Table from '../Table/Table';
import QuestionnaireResultTable from '../Questionnaire/QuestionnaireResultTable';
import WeightChart from '../Shared/Charts/WeightChart';

loadDOMComponent({
	selector: 'react-meddi-oncology',
	callback: ({ container, context, props }) => {
		const patientId = container.getAttribute('patientId');

		const items = [
			{
				title: '1.4',
				items: [
					{
						title: '12:45 - Popis 1',
						color: '#b6d3fc',
						onClick: [],
					},
					{
						title: '12:45 - Popis 2',
						color: '#3d5cff',
						onClick: [],
					},
					{
						title: '12:45 - Popis 3',
						color: '#62a2ff',
						onClick: [],
					},
				],
			},
			{
				title: '20.4',
				items: [
					{
						title: '12:45 - Popis 1',
						color: '#b6d3fc',
						onClick: [],
					},
					{
						title: '12:45 - Popis 3',
						color: '#62a2ff',
						onClick: [],
					},
				],
			},
		];

		const legendItems = [
			{
				title: 'test',
				color: '#62a2ff',
				key: 'test',
				onClick: [],
			},
		];

		const educationMaterialsRows = [
			{
				id: 1,
				name: 'Genetické všetření, 2013',
				seen: '11.5.2022',
				type: 'Video',
				date: '9.5.2022',
			},
			{
				id: 2,
				name: 'Strava při onkologickém vyšetření 1',
				seen: '10.5.2022',
				type: 'Link',
				date: '28.4.2022',
			},
		];

		const educationMaterialsColumns = [
			{
				key: 'name',
				title: 'Nazev',
				renderItem: item => {
					return (
						<div className='px-3 py-3'>
							<div className='text-underline'>{item.name}</div>
							<div>
								<span className='text-light-gray'>Zobrazeno:</span> {item.seen}
							</div>
						</div>
					);
				},
			},
			{
				key: 'type',
				title: 'typ',
				renderItem: item => {
					return (
						<div className='d-flex justify-content-center w-100'>
							{item.type}
						</div>
					);
				},
			},
			{
				key: 'date',
				title: 'test',
				renderItem: item => {
					return (
						<div className='d-flex justify-content-center w-100 text-light-gray'>
							{item.date}
						</div>
					);
				},
			},
		];

		ReactDOM.render(
			<AppContextProvider {...context}>
				<Collapse title='base.timeSequence' defaultOpen>
					<TimelineGrid items={items} legendItems={legendItems} showLegend />
				</Collapse>
				<div className={'row'}>
					<div className={'col-lg-6 col-12'}>
						<Collapse title='base.shared.educationMaterials' defaultOpen>
							<Table
								columns={educationMaterialsColumns}
								rows={educationMaterialsRows}
							/>
						</Collapse>
						<QuestionnaireResultTable />
					</div>
					<div className={'col-lg-6 col-12'}>
						<WeightChart patientId={patientId} />
					</div>
				</div>
			</AppContextProvider>,
			container,
		);
	},
});
